import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
import { GroupsService } from '../../groups/groups.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GroupMembershipOption } from '../../groups/models/group-detail.model';
import { of, Observable } from 'rxjs';
import { SignInProposeService } from '../modals/signin-propose/signin-propose.service';

@Injectable({ providedIn: 'root' })
export class GroupSelectedGuard  {
  constructor(private auth: AuthService, private router: Router, private groupsService: GroupsService,
    private _signInProposeService: SignInProposeService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.enableGroupsSelection && !this.auth.idenediGroupId) {
      this.groupsService.setGoBackUrl('/auth/login');
      this._signInProposeService.setRedirectPath(state.url);
      this.router.navigate(['/groups/choose']);
      return Promise.resolve(false);
    }
    else if (!environment.enableGroupsSelection && this.auth.idenediGroupId) {
      // For single-group app, only check membership if user is properly logged in with valid token
      const isLoggedInWithValidToken = this.auth.isLoggedIn() && !this.auth.isIdenediTokenExpired();
      
      if (isLoggedInWithValidToken && !state?.url?.includes('membershipRequired')) {
        return this.groupsService.getGroupDetailsPublic(this.auth.idenediGroupId)
          .pipe(
            switchMap((group) => {
              if (group.GroupMembershipStatus !== "Admin" &&
                group.GroupMembershipStatus !== "Member") {
                if (group.GroupSettings.GroupMembershipOption === GroupMembershipOption.AnyoneCanJoin) {
                  return this.groupsService.joinGroup(environment.idenediGroupId, null, route.queryParams.key).pipe(map(_ => true), catchError(err => of(false)));
                }
                this.router.navigate([`/groups/join/${this.auth.idenediGroupId}`]);
                return of(false);
              } else {
                return of(true);
              }
            }),
            catchError(error => {
              console.error('GroupSelectedGuard: API error, allowing access:', error);
              // On API error (e.g., token expired but not detected), allow access
              // The auth guard or other mechanisms will handle authentication
              return of(true);
            })
          );
      }

    }

    return Promise.resolve(true);
  }
}
